"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
const openfga_client_1 = require("./openfga-client");
const featureGetters = {
    on: {
        tier: async (tier) => {
            return await (0, openfga_client_1.readObjects)(`tier:${tier}`, "associated_tier", "feature:");
        },
        channel: async (channel) => {
            return await (0, openfga_client_1.readObjects)(`channel:${channel}`, "associated_channel", "feature:");
        },
    },
};
const tierGetters = {
    for: {
        user: async (userId) => {
            return (await (0, openfga_client_1.readObjects)(`user:${userId}`, "direct_subscriber", "tier:")).firstOrUndefined();
        },
        organization: async (orgId) => {
            return (await (0, openfga_client_1.readObjects)(`organization:${orgId}`, "subscriber", "tier:"))?.firstOrUndefined();
        },
    },
};
const channelGetters = {
    for: {
        user: async (userId) => {
            return (await (0, openfga_client_1.readObjects)(`user:${userId}`, "direct_subscriber", "channel:"))?.firstOrUndefined();
        },
        organization: async (orgId) => {
            return (await (0, openfga_client_1.readObjects)(`organization:${orgId}`, "subscriber", "channel:"))?.firstOrUndefined();
        },
    },
};
const contactGetters = {
    that: {
        user: (userId) => ({
            can_view: async () => {
                return await (0, openfga_client_1.listObjects)(`user:${userId}`, "can_view", "contact");
            },
            can_edit: async () => {
                return await (0, openfga_client_1.listObjects)(`user:${userId}`, "can_edit", "contact");
            },
            owns: async () => {
                return await (0, openfga_client_1.listObjects)(`user:${userId}`, "owns", "contact");
            },
        }),
    },
};
const userGetters = {
    that: {
        owns: {
            contact: async (contactId) => {
                return (await (0, openfga_client_1.readUsers)("owns", `contact:${contactId}`))?.firstOrUndefined();
            },
        },
    },
};
const usersGetters = {
    with_elevated_access_in: {
        organization: async (orgId) => {
            return await (0, openfga_client_1.readUsers)("elevated_access", `organization:${orgId}`);
        },
    },
    with_full_access_in: {
        organization: async (orgId) => {
            return await (0, openfga_client_1.readUsers)("full_access", `organization:${orgId}`);
        },
    },
    member_in: {
        organization: async (orgId) => {
            return await (0, openfga_client_1.readUsers)("member", `organization:${orgId}`);
        },
    },
    who_can_view_all_contacts_in: {
        organization: async (orgId) => {
            return await (0, openfga_client_1.readUsers)("can_view_all_contacts", `organization:${orgId}`);
        },
    },
    who_can_edit_all_contacts_in: {
        organization: async (orgId) => {
            return await (0, openfga_client_1.readUsers)("can_edit_all_contacts", `organization:${orgId}`);
        },
    },
};
exports.get = {
    channel: channelGetters,
    features: featureGetters,
    tier: tierGetters,
    contacts: contactGetters,
    user: userGetters,
    users: usersGetters,
};
//# sourceMappingURL=getters.js.map